export const LESS_THAN = "<";
export const LESS_THAN_OR_EQUAL_TO = "<=";
export const EQUAL_TO = "=";
export const GREATER_THAN_OR_EQUAL_TO = ">=";
export const GREATER_THAN = ">";

export const NOT_EQUAL_TO = "!=";

export const MINUTES = "minutes";
export const HOURS = "hours";
export const DAYS = "days";
export const WEEKS = "weeks";
